<template>
  <div>
    <el-form label-width="100px" >
      <el-form-item label="选择分数：">
        <el-select v-model="scoreId" value-key="id" placeholder="请选择" style="width:10em;" @change="scoreChange">
          <el-option v-for="item in scoreList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-checkbox v-model="isScore" style="margin-left: 16px;">不评分</el-checkbox>
      </el-form-item>
      <el-form-item label="评分内容：">
        <p>{{msg}}</p>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="margin-bottom: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getFormData, postFormData} from "@/api/api";
import { updateResumeScore } from "@/api/url";
export default {
  name: "ScoreDialog",
  props: {
    value: Object,
  },
  data() {
    return {
      scoreList: this.value.scoreList,
      scoreId: this.value.scoreList[0].value,
      msg: this.value.scoreList[0].msg,
      idArray: this.value.idArray,
      loading: false,
      isScore: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    scoreChange(val) {
      for (let i = 0; i<this.scoreList.length; i++) {
        if (this.scoreList[i].value == val) {
          this.msg = this.scoreList[i].msg
        }
      }
    },

    summit() {
      let _this = this;
      this.loading = true;
      let param = {};
      param['idArr'] = this.idArray;
      param['scoreId'] = !this.isScore?this.scoreId:0;
      postFormData(updateResumeScore, param).then(function(data) {
        let {
          code,
          msg
        } = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          _this.loading = false;
          _this.$emit('confirm')
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
          _this.$emit('close')
        }
      })
          .catch(function(response) {
            _this.loading = false;
          })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
